var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"select-buttons",class:{ full: _vm.isFull() }},_vm._l((_vm.options),function(option){return _c('a',{key:option[_vm.fieldId],class:{ active: _vm.isActive(option[_vm.fieldId]) },on:{"click":function($event){return _vm.toggle(option[_vm.fieldId])}}},[_vm._v(_vm._s(option[_vm.fieldName]))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }